import {
  ActionStore,
  ChecklistStore,
  GroupedItemVM, GroupedItemsVM,
  ImageMarkerVM, ImageMarkersVM,
  RuleVM,
  TemplateStore
} from "@cmodules/checklist/assets/data/types"
import { AnyItemVM } from "@cmodules/checklist/assets/data/types/vm/template-builder/item"
import { syncRelations } from "@cmodules/checklist/utility/templateBuilderContext-new"
import { isSingleTemplateFirstRevision } from "@csrc/modules/checklist/utility/template-builder-utilities"
import _ from 'lodash'

let tempState: ChecklistStore

export const handleTemplateSetInfo = (state: ChecklistStore, action: ActionStore): ChecklistStore => {
  const data: Partial<TemplateStore> = action.payload
  let currentItem = state.ui.currentItem
  if (isSingleTemplateFirstRevision(data) && data?.present?.items[1]) {
    currentItem = data?.present?.items[1]
  }
  return {
    ...state,
    ui: {
      ...state.ui,
      currentItem
    },
    template: {
      ...state.template,
      ...data
    }
  }
}

export const handleTemplateEdit = (state: ChecklistStore, action: ActionStore): ChecklistStore => {
  const clk_template_edit_data = action.payload.template
  tempState = _.cloneDeep(state)
  const past = _.cloneDeep(tempState.template.past)
  if (action.payload.sendEditRequest) {
    past.push(tempState.template.present)
  }
  /** For Reorder only to choose the item after reordering */
  if (clk_template_edit_data.itemId) {
    tempState.ui.currentItem = _.find(clk_template_edit_data.items, (x: AnyItemVM) => x.id === clk_template_edit_data.itemId) || {}
  }
  const relations = syncRelations({ ...state.template, present: clk_template_edit_data })
  // const relations = clk_template_edit_data.relations
  // delete clk_template_edit_data.relations
  return {
    ...tempState,
    template: {
      ...tempState.template,
      past,
      present: action.payload.template,
      future: [],
      relations
    }
  }
}

export const handleToggleHidePages = (state: ChecklistStore, action: ActionStore): ChecklistStore => {
  return {
    ...state,
    hidePages: !state.hidePages
  }
}

export const handleTemplateSetModalsInfo = (state: ChecklistStore, action: ActionStore): ChecklistStore => {
  return {
    ...state,
    modals: {
      ...state.modals,
      ...action.payload
    }
  }
}

export const handleAddRuleSet = (state: ChecklistStore, action: ActionStore): ChecklistStore => {
  return {
    ...state,
    template: {
      ...state.template,
      rule_sets: {
        ...state.template.rule_sets,
        [action.payload.uuid]: action.payload
      }
    }
  }
}

export const handleAddGroupedItem = (state: ChecklistStore, action: ActionStore): ChecklistStore => {
  return {
    ...state,
    template: {
      ...state.template,
      grouped_items: {
        ...state.template.grouped_items,
        [action.payload.uuid]: action.payload
      }
    }
  }
}

export const handleAddInfo = (state: ChecklistStore, action: ActionStore): ChecklistStore => {
  return {
    ...state,
    template: {
      ...state.template,
      info: {
        ...state.template.info,
        [action.payload.uuid]: action.payload
      }
    }
  }
}

export const handleAddImageMarker = (state: ChecklistStore, action: ActionStore): ChecklistStore => {
  return {
    ...state,
    template: {
      ...state.template,
      image_markers: {
        ...state.template.image_markers,
        [action.payload.uuid]: action.payload
      }
    }
  }
}

export const handleAddResponseSet = (state: ChecklistStore, action: ActionStore): ChecklistStore => {
  return {
    ...state,
    template: {
      ...state.template,
      response_sets: {
        ...state.template.response_sets,
        [action.payload.uuid]: action.payload
      }
    }
  }
}

export const handleSyncGlobalResponses = (state: ChecklistStore, action: ActionStore): ChecklistStore => {
  return {
    ...state,
    template: {
      ...state.template,
      global_responses: action.payload
    }
  }
}

export const handleTemplateUndo = (state: ChecklistStore, action: ActionStore): ChecklistStore => {
  return {
    ...state,
    template: { ...state.template, ...action.payload }
  }
}

export const handleTemplateRedo = (state: ChecklistStore, action: ActionStore): ChecklistStore => {
  return {
    ...state,
    template: { ...state.template, ...action.payload }
  }
}

export const handleTemplateEditPageTitle = (state: ChecklistStore, action: ActionStore): ChecklistStore => {
  tempState = { ...state }
  try {
    const item = tempState.template.present.items.find(x => x.id === action.payload.id)
    if (item) {
      item.title = action.payload.title
    }
  } catch (e) {
  }
  return tempState
}

export const handleTemplateToggleTranslationMultiSelectMode = (state: ChecklistStore, action: ActionStore): ChecklistStore => {
  if (!state.translationMultiSelectMode && action.payload || state.translationMultiSelectMode && !action.payload) {
    tempState = { ...state }
    tempState.translation.multipleItems = {}
    tempState.translationMultiSelectMode = action.payload
    return tempState
  } else {
    return state
  }
}

export const handleTemplateEmptyTranslationMultiSelectItems = (state: ChecklistStore, action: ActionStore): ChecklistStore => {
  tempState = { ...state }
  tempState.translation.multipleItems = {}
  return tempState
}

export const handleTemplateSetItemsToTranslationMultipleSelectedItems = (state: ChecklistStore, action: ActionStore): ChecklistStore => {
  tempState = _.cloneDeep(state)
  _.forEach(action.payload, (itemId: string) => {
    if (tempState.translation.multipleItems[itemId]) {
      delete tempState.translation.multipleItems[itemId]
    } else {
      tempState.translation.multipleItems = {
        ...tempState.translation.multipleItems,
        [itemId]: true
      }
    }
  })
  return tempState
}

export const handleTemplateCopySelectedItemsToClipboard = (state: ChecklistStore, action: ActionStore): ChecklistStore => {
  tempState = { ...state }
  const items: AnyItemVM[] = _.cloneDeep([
    ..._.map(_.filter(tempState.template.present.items, (ss: AnyItemVM) => tempState.ui.multipleItems[ss.id]), x => {
      return x as AnyItemVM
    })
  ])
  const listData: AnyItemVM[] = _.map(items, x => {
    if (!_.find(items, item => item.id === x.parent_id)) {
      const editedItem = x as AnyItemVM
      editedItem.parent_id = null
      return editedItem
    } else {
      return x as AnyItemVM
    }
  })
  tempState.ui.clipboard = listData
  tempState.ui.multipleItems = {}
  tempState.ui.currentItem = {} as AnyItemVM
  tempState.ui.currentSubItem = {} as AnyItemVM
  tempState.multiSelectMode = false
  return tempState
}

export const handleTemplateSavePastItems = (state: ChecklistStore, action: ActionStore): ChecklistStore => {
  const rule_sets_past_items: Record<string, any> = {}
  const image_markers_past_items: ImageMarkersVM = {}
  const grouped_items_past_items: GroupedItemsVM = {}
  _.forEach(action.payload.rules, (rule_set: RuleVM) => {
    rule_sets_past_items[rule_set.uuid] = rule_set
  })
  _.forEach(action.payload.image_markers, (image_marker: ImageMarkerVM) => {
    image_markers_past_items[image_marker.uuid] = image_marker
  })
  _.forEach(action.payload.grouped_items, (grouped_item: { data: GroupedItemVM }) => {
    grouped_items_past_items[grouped_item.data.uuid] = grouped_item.data
  })
  return {
    ...state,
    template: {
      ...state.template,
      rule_sets: {
        ...state.template.rule_sets,
        ...rule_sets_past_items
      },
      image_markers: {
        ...state.template.image_markers,
        ...image_markers_past_items
      },
      grouped_items: {
        ...state.template.grouped_items,
        ...grouped_items_past_items
      }
    }
  }
}

export const handleTemplateUpdateRevisionKey = (state: ChecklistStore, action: ActionStore): ChecklistStore => {
  tempState = { ...state }
  tempState.template.present.revision = action.payload.revision
  tempState.template.present.options = action.payload.options
  return tempState
}

export const LegacyCases = {
  CLK_TEMPLATE_SET_INFO: handleTemplateSetInfo,
  CLK_TEMPLATE_EDIT: handleTemplateEdit,
  CKL_TOGGLE_HIDE_PAGES: handleToggleHidePages,
  CLK_TEMPLATE_SET_MODALS_INFO: handleTemplateSetModalsInfo,
  CKL_ADD_RULE_SET: handleAddRuleSet,
  CKL_ADD_GROUPED_ITEM: handleAddGroupedItem,
  CKL_ADD_INFO: handleAddInfo,
  CKL_ADD_IMAGE_MARKER: handleAddImageMarker,
  CKL_ADD_RESPONSE_SET: handleAddResponseSet,
  CKL_SYNC_GLOBAL_RESPONSES: handleSyncGlobalResponses,
  CLK_TEMPLATE_UNDO: handleTemplateUndo,
  CLK_TEMPLATE_REDO: handleTemplateRedo,
  CLK_TEMPLATE_EDIT_PAGE_TITLE: handleTemplateEditPageTitle,
  CLK_TEMPLATE_TOGGLE_TRANSLATION_MULTI_SELECT_MODE: handleTemplateToggleTranslationMultiSelectMode,
  CLK_TEMPLATE_EMPTY_TRANSLATION_MULTI_SELECT_ITEMS: handleTemplateEmptyTranslationMultiSelectItems,
  CLK_TEMPLATE_SET_ITEMS_TO_TRANSLATION_MULTIPLE_SELECTED_ITEMS: handleTemplateSetItemsToTranslationMultipleSelectedItems,
  CLK_TEMPLATE_COPY_SELECTED_ITEMS_TO_CLIPBOARD: handleTemplateCopySelectedItemsToClipboard,
  CLK_TEMPLATE_SAVE_PAST_ITEMS: handleTemplateSavePastItems,
  CLK_TEMPLATE_UPDATE_REVISION_KEY: handleTemplateUpdateRevisionKey
}

export type LegacyActionType = keyof typeof LegacyCases
export const LEGACY_ACTION_TYPES: { [K in LegacyActionType]: K } = Object.fromEntries(
  Object.keys(LegacyCases).map((key) => [key, key])
) as { [K in LegacyActionType]: K }

export type ActionHandler = typeof LegacyCases[LegacyActionType]
